import React from 'react'

// styles
import * as SC from './TagStyles'

type Props = {
	label: React.ReactNode
	disabled?: boolean
	count?: number
	onCloseBtnClick?: () => void
	closeAriaLabel?: string
}

const Tag = (props: Props) => {
	const { label, onCloseBtnClick, count, disabled, closeAriaLabel } = props

	return (
		<SC.Tag>
			<SC.Label>{count !== undefined ? `${label} (${count})` : label}</SC.Label>

			<SC.CloseButton
				type={'button'}
				aria-label={closeAriaLabel}
				onClick={(e) => {
					e.stopPropagation()
					if (onCloseBtnClick) {
						onCloseBtnClick()
					}
				}}
				disabled={disabled}
			>
				<SC.CloseIcon aria-hidden />
			</SC.CloseButton>
		</SC.Tag>
	)
}

export default Tag
